<template>
  <section :data-test="'barring-status-' + type">
    <div class="notification">
      <div class="row">
        <div class="col-l-11 col-s-12">
          <div class="notification-heading offset-top-1">
            <template v-if="!hasItems">
              {{ status }}
            </template>
            <div v-else class="row">
              <div class="col-l-8 col-m-6 col-s-12">
                {{ status }}
              </div>
              <div class="col-l-4 col-m-6 col-s-12 offset-s-top-1">
                <ul class="list-unordered">
                  <li v-for="item in items">
                    <img
                      v-if="!(type === 'exceptions' || type === 'category-exceptions')"
                      class="scale"
                      :src="exceptionItems(item)"
                      alt=""
                      aria-hidden="true"
                    />
                    {{ $tm('barring.contentTypeCode_', item.name) }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-l-1 col-s-hide col-xs-hide">
          <img class="pull-right" :src="icon" alt="" aria-hidden="true" width="50" height="50" style="vertical-align: middle" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint vue/require-v-for-key: 0 */

export default {
  name: 'BarringStatus',

  props: {
    type: {
      type: String,
      required: true,
    },

    isBarred: {
      type: Boolean,
      required: true,
    },

    items: {
      type: Array,
      required: false,
      default: null,
    },
  },

  computed: {
    icon() {
      if (this.type === 'exceptions' || this.type === 'category-exceptions') return require('@/assets/images/barring/status-solid-exceptions.svg');
      return require(`@/assets/images/barring/status-solid-` + (this.isBarred ? 'lock' : 'unlock') + `.svg`);
    },

    noticeItem() {
      // statusType_factoring / statusType_voiceFactoring / statusType_reselling
      return this.$t(`barring.statusType_${this.type}`);
    },

    hasItems() {
      return this.items && this.items.length > 0;
    },

    status() {
      if (this.type === 'exceptions') {
        // noticeStatusBarred / noticeStatusUnbarred
        return this.$t('barring.noticeSomeVoicePartersPartiallyStatus', {
          status: this.$t(`barring.noticeStatus${this.isBarred ? 'Barred' : 'Unbarred'}`),
        });
      }
      if (this.type === 'category-exceptions') {
        return this.$t('barring.noticeSomeContentTypesPartiallyStatus', {
          status: this.$t(`barring.noticeStatus${this.isBarred ? 'Barred' : 'Unbarred'}`),
        });
      }
      // noticeAllNameAreStatus / noticeSomeNameAreStatus
      return this.$t(`barring.notice${this.hasItems ? 'Some' : 'All'}NameAreStatus`, {
        name: this.noticeItem,
        status: this.$t(`barring.noticeStatus${this.isBarred ? 'Barred' : 'Unbarred'}`),
      });
    },
  },

  methods: {
    exceptionItems(item) {
      return require(`@/assets/images/barring/status-solid-` + (item.isBarred ? 'lock' : 'unlock') + `.svg`);
    },
  },
};
</script>

<style scoped>
.list-unordered {
  max-height: 118px;
  padding: 0;
  margin: 0;
  overflow-y: auto;
  font-size: 18px;
  font-weight: normal;
}
.scale {
  width: 1em;
  height: 1em;
  margin-bottom: -2px;
}
</style>
